module.exports = __webpack_public_path__ + "media/assets/article-icon-3-f34234d98aaf3d072229d214a6071b552f8c329a3bce7110437e8356bc5a8833.png";